import React, { useEffect, useState } from 'react';
import { Container, Form, Row, Col, Button } from '@themesberg/react-bootstrap';
import { get, post } from '../../../../services/back.service';
import LoadingSpinner from '../../../shared/loaderSpinner';
import useAutosave from '../../../../hooks/useAutosave';

function FormCompMotorCompMoto({ id }) {
  const [isLoading, setIsLoading] = useState(false);
  const [msgButton, setMsgButton] = useState('Guardar Informacion')
  const [infoMotorComplement, setInfoCompFluids] = useState({
    Radiator: 0,
    scissor_bushings: 0,
    Engine_Covers: 0,
    speed_box_cover: 0,
    side_stand: 0,
    central_stand: 0,
  });
  const [states, setStates] = useState([]);

  const autosave = useAutosave(async () => {
    await post('/peritaje/modifyinspection/components/' + id, { type: 'MC', data: infoMotorComplement });
  });

  const handleForm = ({ target }) => {
    const tmpMotorComplement = { ...infoMotorComplement, [target.name]: target.value }
    setInfoCompFluids(tmpMotorComplement);
    autosave.schedule();
    //generalUpdate('infoMotorComplement', tmpMotorComplement)

  };

  const getInfoState = async () => { //infostate
    const respoInfo = await get(`/peritaje/infostate/C`, {});
    if (respoInfo.success) {
      const { stateapp } = respoInfo.data
      const currentDefaultState = stateapp.find((e) => e.name.toLowerCase() === 'bueno');
      setInfoCompFluids({
        scissor_bushings: currentDefaultState.id,
        speed_box_cover: currentDefaultState.id,
        Radiator: currentDefaultState.id,
        Engine_Covers: currentDefaultState.id,
        side_stand: currentDefaultState.id,
        central_stand: currentDefaultState.id,
      });
      setStates(stateapp);
    } else {
      console.log(respoInfo.message);
    }
  };

  const sendInfo = async (event) => {
    event.preventDefault();
    autosave.cancel();
    const body = { type: 'MC', data: infoMotorComplement };
    const respo = await post('/peritaje/modifyinspection/components/' + id, body);
    if (respo.success) {
      setMsgButton('Actualizar')
    }
  };
  useEffect(() => {
    const initForm = async () => {
      setIsLoading(true);
      const body = { type: 'MC' };
      const tmpMotor = {};
      const respo = await post(
        '/peritaje/infodetailinspection/components/' + id,
        body,
      );
      if (respo.success) {
        const { detail } = respo.data;
        for (let i = 0; i < detail.length; i++) {
          const element = detail[i];
          tmpMotor[element.name] = element.id_state;
        }
        if (detail.length > 0) setInfoCompFluids(tmpMotor);
      }
      setIsLoading(false);
    };
    getInfoState();
    initForm();
  }, [id]);

  return (isLoading) ? <LoadingSpinner /> : (
    <Container>
      <Row className="mb-1">
        <Col>
          <h1 className="fw-bold">COMPLEMENTOS DE MOTOR</h1>
        </Col>
      </Row>
      <hr style={{ opacity: 0.1 }} />
      <Row>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="scissor_bushings">Bujes de Tijera</Form.Label>
          <Form.Select
            name="scissor_bushings"
            value={infoMotorComplement.scissor_bushings}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="speed_box_cover">Tapa Caja Velocidades</Form.Label>
          <Form.Select
            name="speed_box_cover"
            value={infoMotorComplement.speed_box_cover}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="Radiator">Radiador</Form.Label>
          <Form.Select
            name="Radiator"
            value={infoMotorComplement.Radiator}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="Engine_Covers">Tapas de Motor</Form.Label>
          <Form.Select
            name="Engine_Covers"
            value={infoMotorComplement.Engine_Covers}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="side_stand">Caballete Lateral</Form.Label>
          <Form.Select
            name="side_stand"
            value={infoMotorComplement.side_stand}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="central_stand">Caballete Central</Form.Label>
          <Form.Select
            name="central_stand"
            value={infoMotorComplement.central_stand}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
      </Row>
      <Row className="my-3">
        <Col className="d-flex justify-content-end">
          <Button type="button" variant="primary" onClick={sendInfo}>
            {msgButton}
          </Button>
        </Col>
      </Row>
    </Container>
  );
}

export default FormCompMotorCompMoto;
